<template>
    <div class="content-left">
        <div class="image-box">
            <img src="@/assets/image/ren.png" />
        </div>
        <p>
            <el-tag size="mini">
                {{ $t('studentDetail.X') }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('studentDetail.M') }}
            </el-tag>
            <span class="team-name">{{ teamData.playerName }}</span>
            <!-- <el-input v-else v-model="teamName" @blur="$parent.saveTeam(teamName); isModifyTeamName = false" size="mini" maxlength="20" placeholder="请输入新的团队名称" style="width: 150px"></el-input>
            <span class="icon-modify el-icon-edit-outline" @click="isModifyTeamName = true"></span> -->
        </p>
        <p v-auth="[['teacher', 'student'], 'pro']" v-show="queryData.pattern_lx != 2">
            <el-tag size="mini">
                {{ $t('studentDetail.SSBJ') }}
            </el-tag>
            <span class="leader-name">
                {{ teamData.className ? teamData.className : '--' }}
            </span>
        </p>
        <p>
            <el-tag size="mini">
                {{ $t('studentDetail.LXZT') }}
            </el-tag>
            <span class="status-text red">
                {{ processStatusName[queryData.processStatus ? queryData.processStatus : teamData.processStatus] }}
            </span>
        </p>
        <span v-if="__userData.userType > 1">
            <p>
                <el-tag size="mini">
                    {{ $t('studentDetail.LXSJ') }}
                </el-tag>
                <!-- <br /> -->
                <span class="leader-name" :title="teamDataReset.beginTime + '--' + teamDataReset.endTime">
                    {{ teamDataReset.beginTime }}--{{ teamDataReset.endTime }}
                </span>
            </p>
            <p>
                <el-tag size="mini">
                    {{ $t('studentDetail.LXMS') }}
                </el-tag>
                <span class="leader-name">
                    {{ teamData.rule == 1 ? $t('studentDetail.XH') : $t('studentDetail.DC') }}{{ $t('studentDetail.LX') }}
                </span>
            </p>
            <p>
                <el-tag size="mini">
                    {{ $t('studentDetail.LXTest') }}
                </el-tag>
                <span class="leader-name nowrap" :title="teamData.paperName">
                    {{ teamData.paperName }}
                </span>
            </p>
        </span>
    </div>
</template>
<script>
export default {
    name: 'contentLeft',

    data() {
        return {
            teamName: '',
            isModifyTeamName: false,
            processStatusName: [this.$t('studentDetail.WKS'), this.$t('studentDetail.JXZ'), this.$t('studentDetail.YWC')]
        }
    },
    props: {
        teamData: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        teamDataReset() {
            return {
                beginTime: this.teamData.beginTime?.replaceAll('-', '.'),
                endTime: this.teamData.endTime?.replaceAll('-', '.')
            }
        },
        queryData() {
            return JSON.parse(this.__Base64.decode(this.$route.query.q))
        }
    },
    watch: {
        teamData(newVal) {
            if (newVal.teamName) {
                this.teamName = this.teamData.teamName
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.content-left {
    width: 400px;
}

.image-box {
    width: 240px;
    height: 240px;

    img {
        width: 100%;
        height: 240px;
    }
}

p {
    margin: 12px 0;
    @include flex();

    .team-name {
        margin: 0 8px 0 0;
        font-size: 16px;
        font-family: Hiragino Sans GB;
        font-weight: normal;
        color: #0D141E;
        letter-spacing: 2px;
    }

    .icon-modify {
        color: #5397F7;
        font-size: 16px;
    }

    .icon-modify:hover {
        cursor: pointer;
        opacity: .8;
    }

    /deep/ .el-tag {
        margin-right: 16px;
    }

    .leader-name,
    .status-text {
        font-size: 14px;
        font-family: Hiragino Sans GB;
        font-weight: normal;
        color: #5D646E;
        display: inline-block;
        // width: 160px;
    }

    .red {
        color: #F77981;
    }
}
</style>